import { useQuery } from '@tanstack/react-query'

import {
  defaultEnrollmentStatus,
  getEnrollmentStatus
} from '../../api/enrollments/get-enrollment-status'

/**
 * The enrollment status the backend computes (payment, confirmation readiness, age compliance).
 *
 * Shares the `['enrollment', id, 'status']` query key so every component reading the status hits
 * the same cache entry instead of prop drilling it down the enrollment form.
 */
export function useEnrollmentStatus(enrollmentId?: number) {
  return useQuery({
    enabled: !!enrollmentId,
    initialData: defaultEnrollmentStatus,
    queryKey: ['enrollment', enrollmentId, 'status'],
    queryFn: () => getEnrollmentStatus(enrollmentId as number)
  })
}
